import axios from "axios";

export interface FirebaseTopicParameters {
  token: string;
  topic: string;
}

export const firebaseTopic = {
  subscribe: async (payload: FirebaseTopicParameters) => {
    if (!payload.token) {
      throw new Error("Invalid fcm token");
    }
    await axios.post<void, void, FirebaseTopicParameters>("/subscribeTopic", payload);
  },
  unsubscribe: async (payload: FirebaseTopicParameters) => {
    if (!payload.token) {
      throw new Error("Invalid fcm token");
    }
    await axios.post<void, void, FirebaseTopicParameters>("/unsubscribeTopic", payload);
  },
};
